import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { useState } from 'react';

export const STOP_MESSAGE_PRESETS = [
  {
    id: 'stop-1',
    text: 'Text STOP to unsubscribe'
  },
  {
    id: 'stop-2',
    text: 'Reply STOP to end messages'
  },
  {
    id: 'stop-3',
    text: 'STOP = no more messages'
  }
];

interface StopMessageDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedMessage: string;
  onMessageSelected: (message: string) => void;
}

export function StopMessageDialog({
  open,
  onOpenChange,
  selectedMessage,
  onMessageSelected
}: StopMessageDialogProps) {
  // Track selected value internally until save
  const [selectedId, setSelectedId] = useState(() => {
    const preset = STOP_MESSAGE_PRESETS.find((p) => p.text === selectedMessage);
    return preset?.id ?? STOP_MESSAGE_PRESETS[0].id;
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[532px]">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">{`Select "Stop" Message`}</DialogTitle>
          <p className="text-sm text-muted-foreground">
            These are the presets you can use to let your customers unsubscribe.
          </p>
        </DialogHeader>
        <div className="p-6 space-y-4">
          <RadioGroup value={selectedId} onValueChange={setSelectedId} className="space-y-3">
            {STOP_MESSAGE_PRESETS.map((preset) => (
              <div
                key={preset.id}
                className="relative rounded-lg border border-slate-200 bg-background transition-colors hover:bg-accent/50 [&:has([data-state=checked])]:border-primary [&:has([data-state=checked])]:bg-primary/5"
              >
                <RadioGroupItem value={preset.id} id={preset.id} className="sr-only" />
                <Label
                  htmlFor={preset.id}
                  className="block w-full p-4 text-base font-normal cursor-pointer"
                >
                  {preset.text}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>
        <DialogFooter className="sm:justify-between">
          <Button
            variant="ghost"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              const selectedPreset = STOP_MESSAGE_PRESETS.find((p) => p.id === selectedId);
              if (selectedPreset) {
                onMessageSelected(selectedPreset.text);
              }
              onOpenChange(false);
            }}
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
